

import {Component, Vue} from 'vue-property-decorator'
import ModalAccept from "@/components/modal-accept/index.vue";
import Input from "@/components/input2/index.vue";
import user_module from "@/modules/user/index";

import Toasted from 'vue-toasted';
import Loader from "@/components/loader/Loader.vue";
import ShowPassword from "@/components/show-password/index.vue";

const toastOptions = {

  position: "top-left",
  duration: 3000,
  iconPack: "fontawesome",
  theme: "outline",
  type: "success",
  icon: "check"
}

Vue.use(Toasted, toastOptions)


@Component({
    components: {
      ModalAccept,
      Input,
      Loader,
      ShowPassword
    }
})

export default class Login extends Vue {

    public login: string =  user_module.userInfo.Email
    public password: string = '';

    invalidHeaderText: string = 'Invalid Access Details';
    invalidContentText: string = 'Wrong username/password or your account/account password has expired. Please check your credentials or contact us at 800-282-4567, clientsuccess@rixtrema.com';
    openedInvalidModal: boolean = false;
    loading: number = 0;
    password_is_displayed: boolean = false

    
    get isMobile(){

      return user_module.isMobile;
    }

    displayPassword() {

      this.password_is_displayed = !this.password_is_displayed

    }


    async signIn(e: any) {

      e.preventDefault();

      this.loading = 1

      const success = await user_module.getLogin({login: this.login, password: this.password});

      this.loading = 0;
      
      if (success){
        
        if (!this.isMobile){

          this.$toasted.show(`<b>Logged in successfully</b>`)

        }

        let route = '/';

        const redirect = this.$route.query.redirect;

        if (redirect && typeof redirect === 'string'){

          route = redirect;
        }

        this.$router.push(route);
        user_module.setFirstIframe(true);

      } else {

        this.openedInvalidModal = true;

      }

    }

    closeInvalidModal(){

      this.openedInvalidModal = false;
    }

    mounted(){
      const body: any = document.getElementsByTagName('body')[0];
      body.style.height = '100%';
    }

    
    beforeDestroy(){
      const body: any = document.getElementsByTagName('body')[0];
      body.style.height = null;
    }

}

